"use client";

import { useState, useEffect } from 'react';

function isWebGL2Supported(): boolean {
  try {
    const gl = document.createElement('canvas').getContext('webgl2', { failIfMajorPerformanceCaveat: true });
    return !!gl && gl instanceof WebGL2RenderingContext;
  } catch (e) {
    return false;
  }
}

export function useWebGL2(): boolean {
  const [webGL2Supported, setWebGL2Supported] = useState(false);

  useEffect(() => {
    setWebGL2Supported(isWebGL2Supported());
  }, []);
  

  return webGL2Supported;
}
